var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ViewModal from "../ActivityItem/ViewModal";
import MeetingDomainService from "../../../Domain/Meeting/Meeting.service";
import ActivityItemTypeService from "../../../Domain/ActivityItemType/ActivityItemType.service";
import useService from "../../Hooks/useService";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import CustomCard from "../../UI/CustomCard/CustomCard";
import FAIcon from "../../UI/FAIcon/FAIcon";
import MeetingService from "../../../Services/Meeting.service";
import DateService from "../../../Services/Shared/Date.service";
import PersonWithLabel from "../Person/PersonWithLabel/PersonWithLabel";
import ProfilePicture from "../Person/ProfilePicture/ProfilePicture";
import MeetingStatusBadge from "../MeetingStatus/MeetingStatusBadge";
import MeetingStatusDomainService from "../../../Domain/MeetingStatus/MeetingStatus.service";
import { ViewModalFormFormat } from "../../UI/FormFormat/FormFormat";
import Loading from "../../UI/Loading/Loading";
import MeetingForm, { getMeetingFormStateFromMeeting } from "./MeetingForm";
import InfoItems from "../../UI/InfoItems/InfoItems";
import StringUtils from "../../../../util/stringUtils";
const MeetingViewModal = (_a) => {
    var { meetingId, setMeeting, onlyShowCancelledStatus } = _a, modalProps = __rest(_a, ["meetingId", "setMeeting", "onlyShowCancelledStatus"]);
    const [meetingState, getMeeting, meetingActions] = useService(MeetingService.getMeeting);
    const editMeeting = (meeting) => {
        setMeeting(meeting);
        meetingActions.edit(meeting);
    };
    React.useEffect(() => {
        if (modalProps.isOpen) {
            getMeeting(meetingId);
        }
    }, [getMeeting, meetingId, modalProps.isOpen]);
    let badge = _jsx(_Fragment, {});
    if (onlyShowCancelledStatus) {
        if (meetingState.data &&
            meetingState.data.meetingStatus.id ===
                MeetingStatusDomainService.Cancelled.id) {
            badge = (_jsx(MeetingStatusBadge, { meetingStatus: MeetingStatusDomainService.Cancelled }));
        }
    }
    else if (meetingState.data) {
        badge = (_jsx(MeetingStatusBadge, { meetingStatus: meetingState.data.meetingStatus }));
    }
    const modalActions = [
        {
            icon: "fal fa-pencil",
            title: "Edit",
            // eslint-disable-next-line react/display-name
            modalBodyAndFooter: (editProps) => (_jsx(ViewModalFormFormat, { defaultValue: meetingState.data
                    ? getMeetingFormStateFromMeeting(meetingState.data)
                    : undefined, handleSubmit: (state) => {
                    var _a;
                    if (!meetingState.data) {
                        return Promise.reject("There was an error saving the meeting");
                    }
                    const meeting = meetingState.data;
                    /**
                     * Previously "Location" in the UI was storing "Service Delivery Location"
                     * Now We will store Location (Main Location) and Service Location (SDL)
                     * Location is required and Service Location(SDL) is optional
                     * */
                    return MeetingService.editMeeting({
                        id: meeting.id,
                        startTime: DateService.getDateWithTime(state.startDate, state.startTime),
                        endTime: DateService.getDateWithTime(state.endDate, state.endTime),
                        staffPersonId: meeting.staff.personId,
                        studentPersonId: meeting.student.personId,
                        locationId: state.location.id,
                        serviceDeliveryLocationId: state.serviceDeliveryLocation
                            ? state.serviceDeliveryLocation.id
                            : null,
                        meetingTypeId: state.meetingType && state.meetingType.id,
                        // @ts-expect-error - TS2339 - Property 'map' does not exist on type 'TranscriptCourse | TranscriptCourseLite[]'.
                        transcriptCourseIds: (state.courseSections || []).map(
                        // @ts-expect-error - TS7006 - Parameter 'cs' implicitly has an 'any' type.
                        (cs) => cs.transcriptCourseId),
                        serviceOfferingIds: (state.serviceOfferings || []).map((service) => service.id),
                        staffComments: state.comment,
                        shouldSendInvite: state.sendUpdateInvitation,
                        meetingModalityId: (_a = state.meetingModality) === null || _a === void 0 ? void 0 : _a.id,
                        meetingStatusId: state.meetingStatus.id,
                        studentPhoneNumber: state.studentPhoneNumber
                            ? StringUtils.normalizePhoneNumber(state.studentPhoneNumber)
                            : null,
                    })
                        .then(editMeeting)
                        .then(() => editProps.cancelAction());
                }, onCancel: editProps.cancelAction, children: (formVals) => (_jsx(ServiceResult, { state: meetingState, children: (meeting) => {
                        const excludeIds = () => {
                            if ((meeting.meetingStatus.id ===
                                MeetingStatusDomainService.NoShow.id ||
                                meeting.meetingStatus.id ===
                                    MeetingStatusDomainService.Completed.id) &&
                                meeting.endTime &&
                                meeting.endTime <= new Date())
                                return [MeetingStatusDomainService.Scheduled.id];
                            return null;
                        };
                        return (_jsx(MeetingForm, Object.assign({}, formVals, { isNewMeeting: false, staffPerson: meeting.staff, studentPerson: meeting.student, isCancelled: meeting.meetingStatus.id ===
                                MeetingStatusDomainService.Cancelled.id, excludeIds: excludeIds() })));
                    } })) })),
        },
    ];
    if (meetingState.data &&
        meetingState.data.meetingStatus.id !==
            MeetingStatusDomainService.NoShow.id &&
        meetingState.data.meetingStatus.id !==
            MeetingStatusDomainService.Cancelled.id) {
        modalActions.push({
            icon: "fal fa-user-slash",
            title: "No Show",
            // eslint-disable-next-line react/display-name
            modalBodyAndFooter: (noShowProps) => (_jsx(ViewModalFormFormat, { onCancel: noShowProps.cancelAction, handleSubmit: () => {
                    if (!meetingState.data) {
                        return Promise.reject("There was an error loading the meeting to cancel");
                    }
                    return MeetingService.markMeetingAsNoShow(meetingState.data && meetingState.data.id).then(() => {
                        if (!meetingState.data) {
                            throw new Error("This meeting was cancelled, but we were unable to reload the meeting details.");
                        }
                        editMeeting(Object.assign(Object.assign({}, meetingState.data), { cancelled: true, meetingStatus: MeetingStatusDomainService.NoShow }));
                        noShowProps.cancelAction();
                    });
                }, saveButtonContents: (isLoading) => (_jsxs(_Fragment, { children: [isLoading && _jsx(Loading, { addMarginRight: true }), "Ok"] })), children: () => "Are you sure you want to mark this meeting as no show?" })),
        });
    }
    if (meetingState.data &&
        meetingState.data.meetingStatus.id !==
            MeetingStatusDomainService.Cancelled.id) {
        modalActions.push({
            icon: "fal fa-times",
            title: "Cancel",
            // eslint-disable-next-line react/display-name
            modalBodyAndFooter: (cancelProps) => (_jsx(ViewModalFormFormat, { onCancel: cancelProps.cancelAction, handleSubmit: () => {
                    if (!meetingState.data) {
                        return Promise.reject("There was an error loading the meeting to mark as no show");
                    }
                    return MeetingService.cancelMeeting(meetingState.data && meetingState.data.id).then(() => {
                        if (!meetingState.data) {
                            throw new Error("This meeting was cancelled, but we were unable to reload the meeting details.");
                        }
                        editMeeting(Object.assign(Object.assign({}, meetingState.data), { cancelled: true, meetingStatus: MeetingStatusDomainService.Cancelled }));
                        cancelProps.cancelAction();
                    });
                }, saveButtonContents: (isLoading) => (_jsxs(_Fragment, { children: [isLoading && _jsx(Loading, { addMarginRight: true }), "Ok"] })), children: () => "Are you sure you want to cancel this meeting? This cannot be undone." })),
        });
    }
    return (_jsx(ViewModal, Object.assign({}, modalProps, { actions: !meetingState.data ? [] : modalActions, activityItemTypeId: ActivityItemTypeService.MeetingId, activityItemId: meetingId, children: _jsx(ServiceResult, { state: meetingState, children: (meeting) => {
                var _a, _b, _c, _d;
                const meetingLocationValue = meeting.serviceDeliveryLocation
                    ? `${meeting.serviceDeliveryLocation.name} - ${meeting.serviceDeliveryLocation.location.name}`
                    : // This null pointer check is necessary due to some older meeting data apparently having neither office nor campus
                        `${(_a = meeting.location) === null || _a === void 0 ? void 0 : _a.name}`;
                return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "row mb-3", children: [_jsx("div", { className: "col-7", children: _jsxs("h2", { children: [_jsx(FAIcon, { icon: ActivityItemTypeService.getIcon(ActivityItemTypeService.MeetingId), className: `mr-2 text-${ActivityItemTypeService.getColor(ActivityItemTypeService.MeetingId)}` }), MeetingDomainService.getTitleForMeeting(meeting)] }) }), _jsx("div", { className: "col-5 d-flex align-items-center justify-content-end", children: badge })] }), _jsxs("div", { className: "row", children: [_jsx("div", { className: "col-7", children: _jsx(CustomCard, { title: "Info", className: "h-100", children: _jsx("div", { className: "card-body", children: _jsx(InfoItems, { numColumnsLg: 1, numColumnsMd: 1, numColumnsSmAndSmaller: 1, items: [
                                                    {
                                                        label: "Time",
                                                        value: (_jsxs(_Fragment, { children: [DateService.displayWithTime(meeting.startTime, true), meeting.endTime && (_jsxs("span", { children: [" ", "\u2013", " ", DateService.getDaysBetween(meeting.startTime, meeting.endTime) === 0
                                                                            ? DateService.displayJustTime(meeting.endTime)
                                                                            : DateService.displayWithTime(meeting.endTime, true)] })), meeting.selfServiceCheckIn &&
                                                                    !meeting.endTime && (_jsxs("span", { className: "text-success", children: [" ", "- ", _jsx("strong", { children: "In-Progress" })] }))] })),
                                                    },
                                                    {
                                                        label: "Location",
                                                        value: meeting.serviceDeliveryLocation ||
                                                            meeting.location
                                                            ? meetingLocationValue
                                                            : null,
                                                    },
                                                    {
                                                        label: "Modality",
                                                        value: meeting.meetingModality && (_jsx("span", { className: "badge badge-secondary", children: (_b = meeting.meetingModality) === null || _b === void 0 ? void 0 : _b.name })),
                                                    },
                                                    {
                                                        label: "Student Phone Number",
                                                        value: meeting.studentPhoneNumber &&
                                                            StringUtils.formatPhoneNumber(meeting.studentPhoneNumber),
                                                    },
                                                    {
                                                        label: "Staff Comment",
                                                        value: meeting.staffComments,
                                                    },
                                                    {
                                                        label: meeting.selfServiceCheckIn
                                                            ? "Student Comment"
                                                            : "Student Question",
                                                        value: meeting.studentQuestion,
                                                    },
                                                    {
                                                        label: ((_c = meeting.meetingServiceOfferings) === null || _c === void 0 ? void 0 : _c.length) === 1
                                                            ? "Service"
                                                            : "Services",
                                                        value: meeting.meetingServiceOfferings &&
                                                            meeting.meetingServiceOfferings.length > 0
                                                            ? meeting.meetingServiceOfferings.map((meetingServiceOffering, index) => (_jsx("span", { className: "badge badge-secondary mr-1", children: meetingServiceOffering.serviceOffering
                                                                    .name }, index)))
                                                            : null,
                                                    },
                                                    {
                                                        label: ((_d = meeting.meetingTranscriptCourses) === null || _d === void 0 ? void 0 : _d.length) === 1
                                                            ? "Course Section"
                                                            : "Course Sections",
                                                        value: meeting.meetingTranscriptCourses &&
                                                            meeting.meetingTranscriptCourses.length > 0
                                                            ? meeting.meetingTranscriptCourses.map((transcriptCourse, index) => (_jsxs("span", { className: "badge badge-secondary mr-1", children: [transcriptCourse.code, " ", transcriptCourse.section] }, index)))
                                                            : null,
                                                    },
                                                ] }) }) }) }), _jsx("div", { className: "col-5", children: _jsx(CustomCard, { title: "People", className: "h-100", children: _jsxs("div", { className: "card-body", children: [_jsx("div", { className: "mb-3", children: meeting.staff && (_jsx(PersonWithLabel, { fullName: meeting.staff.fullName, photo: _jsx(ProfilePicture, { person: meeting.staff, showProfilePicture: true }), label: "Staff" })) }), meeting.student && (_jsx(PersonWithLabel, { fullName: meeting.student.fullName, photo: _jsx(ProfilePicture, { person: meeting.student, showProfilePicture: true }), label: "Student" }))] }) }) })] })] }));
            } }) })));
};
export default MeetingViewModal;
